import axios from "axios"
import { ITC, ERRORLIST } from "../../util/eventTypes"
import { HttpService } from "./httpService"
import Base from "../../util/baseEvent"
// 最大备选EP数量
const MAX_STORE_IDC_LIST = 5
// 每个EP重连次数
const MAX_RETRY_TIMES = 3
// 每个Idc最大Ping次数
const MAX_PING_TIMES = 3
export default class Discover extends Base {
  constructor(options) {
    super()
    this.storeIdcList = []
    this.discoverFailCount = 0
    this.pingFinished = true
    this.$logger.setPrefix("discover2")
    this.options = options
    this.httpService = new HttpService(options.secret)
    this.storeIdcList = []
    this.enableIdc = ""
    // 默认单个EP的最大直接连接次数是3次
    this.singleIdcConnectTime = MAX_RETRY_TIMES
    // 当前正在执行Ping操作的EP请求列表
    this.pingXhrList = {}
    // 重连次数
    this.discoverFailCount = 0
    // 全部Ping是否结束
    this.pingFinished = true
    this.initEvent()
    this.shiftIdc = this.shiftIdc.bind(this)
    this.log("options", this.options)
  }
  initEvent() {
    // 重连成功以后 重置当前discover次数和当前EPretry次数
    this.eventEmitter.on(ITC.CONNECTED, () => {
      this.discoverFailCount = 0
      this.singleIdcConnectTime = MAX_RETRY_TIMES
    })
  }
  // 开始选点
  start(idcList) {
    this.idcList = idcList
    if (!this.idcList || !this.idcList.length) {
      this.eventEmitter.emit(ITC.ERROR, ERRORLIST.EMPTY_IDC_LIST)
      return
    }
    // 开始连接
    this.log("connecting")
    this.eventEmitter.emit(ITC.START_CONNECT)
    this.once("GET_NODE_SUCCESS", (currentEp, options) => {
      this.eventEmitter.emit(ITC.PING_SUCCESS, currentEp, options)
      this.removeAllListeners("GET_NODE_FAILED")
      // this.eventEmitter.emit(LOG.INFO, "discover_success", {
      //   title: currentEp,
      //   event_type: options.type,
      //   event_steps: "discover"
      // })
      this.$logger.info("discover_success", {
        title: currentEp,
        event_type: options.type,
        event_steps: "discover"
      })
    })
    this.once("GET_NODE_FAILED", () => {
      this.removeAllListeners("GET_NODE_SUCCESS")
      this.eventEmitter.emit(ITC.ERROR, ERRORLIST.ALL_EP_TIMEOUT)
    })
    // 如果有可用IDC 直接消耗可用IDC
    if (this.enableIdc) {
      this.consumeStoreIdc()
      return
    }
    // 如果全部Ping的没有完成 只需要等待下一次ping成功 或者所有的Ping失败
    if (!this.pingFinished) {
      return
    }
    // 如果ping执行次数超过2次 抛出异常
    if (this.discoverFailCount >= 2) {
      this.eventEmitter.emit(ITC.ERROR, ERRORLIST.ABOVE_MAX_DISCOVER_TIMES)
      return
    }
    this.pingFinished = false
    this.discoverFailCount += 1
    this.RaceLoop(this.idcList.slice())
  }
  /**
   * 使用完成Ping的Idc
   * 每调用一次 singleIdcConnectTime-1
   * 当singleIdcConnectTime<=0:
   * 如果有存储 取新值 同时重置singleIdcConnectTime
   * 如果没有 enableIdc=''
   **/
  consumeStoreIdc() {
    this.emit("GET_NODE_SUCCESS", this.enableIdc, {
      type: "store"
    })
    if (--this.singleIdcConnectTime <= 0) {
      this.enableIdc = ""
      this.shiftIdc()
    }
  }
  shiftIdc() {
    if (this.storeIdcList.length > 0) {
      this.enableIdc = this.storeIdcList.shift()
      this.singleIdcConnectTime = MAX_RETRY_TIMES
    }
  }
  /**
   * 从EP列表中获取可用的EP列表
   * EP列表中的每个EP自动执行重连
   * @param list idcList
   * @constructor
   */
  RaceLoop(list) {
    // 排名计数器，取ping最先相应的前几名
    let gradeCounter = 0
    // 参赛者计数器，记录完成竞速的参赛者有多少
    let finishCount = 0
    const resolveHandler = res => {
      finishCount++
      // 参赛者完成3轮竞速ping，并错误次数小于2
      if (res.errorCount < 2) {
        this.reportQualityNode(res.ep)
        // 打点逻辑，记录请求成功
        // this.eventEmitter.emit(LOG.INFO, "ping_success", {
        //   event_steps: "discover",
        //   title: res.ep,
        //   scheduled_time: res.duration.join(","),
        //   time_cost: res.duration.reduce((pre, curr) => {
        //     return pre + curr
        //   })
        // })
        this.$logger.info("ping_success", {
          event_steps: "discover",
          title: res.ep,
          scheduled_time: res.duration.join(","),
          time_cost: res.duration.reduce((pre, curr) => {
            return pre + curr
          })
        })
        gradeCounter++
      }
      // 完成比赛并获得排名的竞速者已满
      if (gradeCounter >= MAX_STORE_IDC_LIST) {
        this.abortXhr()
        this.pingFinished = true
      }
      // 所有竞速者完成竞速
      if (finishCount >= list.length) {
        this.pingFinished = true
        // 当竞速结束备选idcList列表还未空时，选点失败
        if (!this.storeIdcList.length) {
          this.emit("GET_NODE_FAILED")
        }
      }
    }
    for (let idc of list) {
      if (gradeCounter < MAX_STORE_IDC_LIST) {
        this.pingLoop(idc).then(resolveHandler)
      }
    }
  }
  /**
   * 每个EP的ping 循环，封装了ping resolve&reject 逻辑
   * @param ep
   * @param errorCount
   * @param totalCount
   * @param duration
   * @returns {Promise<any>}
   */
  pingLoop(ep, errorCount = 0, totalCount = 0, duration = []) {
    return new Promise((resolve, reject) => {
      if (totalCount < MAX_PING_TIMES && errorCount < 2) {
        this.ping(ep, totalCount + 1).then(
          res => {
            duration.push(res.duration)
            resolve(this.pingLoop(ep, errorCount, ++totalCount, duration))
          },
          err => {
            this.debug(`Ping failed. ${err.message}`)
            // 记录请求失败Log
            // this.eventEmitter.emit(LOG.WARNING, "ping_fail", {
            //   title: ep,
            //   error_msg: `msg:${err.message}.random:${
            //     err.randomId
            //   }.exceptionalCount:${errorCount}`,
            //   event_steps: "discover",
            //   seek_count: totalCount + 1
            // })
            this.$logger.warn("ping_fail", {
              title: ep,
              error_msg: `msg:${err.message}.random:${
                err.randomId
              }.exceptionalCount:${errorCount}`,
              event_steps: "discover",
              seek_count: totalCount + 1
            })
            duration.push(err.duration)
            // 为减少状态管理，统一返回resolve至上游
            resolve(this.pingLoop(ep, ++errorCount, ++totalCount, duration))
          }
        )
      } else {
        resolve({
          ep,
          duration,
          errorCount,
          totalCount
        })
      }
    })
  }
  /**
   * ping方法， 只处理ping本身的逻辑
   * @param idcName
   * @param count 仅兼容httpService.ping中的循环次数参数传递值。此方法不做ping 请求成功或失败次数累积逻辑
   * @returns {Promise<any>}
   */
  ping(idcName, count) {
    return new Promise((resolve, reject) => {
      let strTime = Date.now()
      let randomId = `${Math.random()}`.replace(".", "")
      let CancelToken = axios.CancelToken
      let source = CancelToken.source()
      if (this.pingFinished) {
        reject({
          idcName,
          message: "CANCELED_BY_USER",
          randomId,
          duration: 2000
        })
        return
      }
      this.httpService
        .ping(idcName, source.token, {
          count,
          randomId,
          role: this.options.role,
          userid: this.options.userid,
          roomid: this.options.roomid
        })
        .then(() => {
          resolve({ idcName, duration: Date.now() - strTime })
        })
        .catch(thrown => {
          reject({
            idcName,
            message: thrown.message,
            randomId,
            duration: 2000
          })
        })
      this.pingXhrList[idcName] = source
    })
  }
  // 上报可用EP
  reportQualityNode(idcName) {
    if (!this.enableIdc || !this.enableIdc.length) {
      this.enableIdc = idcName
      this.singleIdcConnectTime = MAX_RETRY_TIMES
    } else {
      this.storeIdcList.push(idcName)
    }
    this.emit("GET_NODE_SUCCESS", idcName, {
      type: "discover"
    })
  }
  // 取消所有的请求
  abortXhr() {
    for (var i in this.pingXhrList) {
      if (this.pingXhrList.hasOwnProperty(i)) {
        this.pingXhrList[i]["cancel"]("CANCELED_BY_USER")
      }
    }
    this.pingXhrList = []
  }
  destroy() {
    this.removeAllListeners("GET_NODE_FAILED")
    this.removeAllListeners("GET_NODE_SUCCESS")
    this.abortXhr()
    this.discoverFailCount = 0
    this.pingFinished = true
  }
}
